// extracted by mini-css-extract-plugin
export var bottom = "Hamburger-module--bottom--dabae";
export var menu = "Hamburger-module--menu--ad8d3";
export var middle = "Hamburger-module--middle--e3a29";
export var toggled = "Hamburger-module--toggled--32a92";
export var top = "Hamburger-module--top--211a9";